import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Search.css';

function Search({ onChange }) {
  const [input, setInput] = useState('');
  const [debouncedInput, setDebouncedInput] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  // Handle typing
  const handleInputChange = (e) => {
    setInput(e.target.value);
  };

  // Debounce typing (wait 500ms)
  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedInput(input);
    }, 500);
    return () => clearTimeout(timeout);
  }, [input]);
const clearSearch = () => {
  setInput("");
  onChange("");
  navigate("/top");
};
 useEffect(() => {
  const timer = setTimeout(() => {
    const trimmed = input.trim();

    onChange(trimmed);

    // only reset pagination if user is searching
    if (trimmed !== "" && !location.pathname.includes("/page/1")) {
      navigate(`/page/1${location.search}`, { replace: true });
    }
  }, 500);

  return () => clearTimeout(timer);
}, [input]);
  return (
    <div className="search">
      <input
        className="search_text"
        type="text"
        placeholder="🔍 Search Blog"
        onChange={handleInputChange}
        value={input}
      />
      {input && (
  <button className="clear_btn" onClick={clearSearch}>
    ❌
  </button>
)}
    </div>
  );
}

export default Search;
